import { BillingPlan, BillingPrice, Subscription } from '../types'

/**
 * Get active subscriptions (active or trialing)
 */
export function getActiveSubscriptions(subscriptions: Subscription[]): Subscription[] {
  return subscriptions.filter((subscription) => subscription.status === 'active' || subscription.status === 'trialing')
}

/**
 * Get a plan by ID
 */
export function getPlanById(plans: BillingPlan[], planId: string): BillingPlan | undefined {
  return plans.find((plan) => plan.id === planId)
}

/**
 * Get a price by ID
 */
export function getPriceById(plans: BillingPlan[], priceId: string): BillingPrice | undefined {
  for (const plan of plans) {
    const price = plan.prices.find((price) => price.id === priceId)
    if (price) {
      return price
    }
  }
  return undefined
}

/**
 * Get active price for a plan based on currency and interval
 */
export function getActivePlanPrice(plan: BillingPlan, options: { currency?: string; interval?: string } = {}): BillingPrice | undefined {
  const { currency = 'usd', interval = 'month' } = options

  // First try to find a price with the exact currency and interval
  let price = plan.prices.find((price) => price.currency.toLowerCase() === currency.toLowerCase() && price.interval === interval)

  // If not found, try to find a price with just the currency
  if (!price) {
    price = plan.prices.find((price) => price.currency.toLowerCase() === currency.toLowerCase())
  }

  // If still not found, return the first price
  if (!price && plan.prices.length > 0) {
    price = plan.prices[0]
  }

  return price
}
